import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SubTenantOverview } from 'src/routes/GMDashboard/modules/types';
import { handleClickTenantName } from 'src/routes/GMDashboard/modules/utils';
import { updateText } from 'src/utils/stringUtils';
import DevicesStatistics from './DevicesStatistics';
import IndividualSubtenantSettings from './IndividualSubtenantSettings';
import PatientsStatistics from './PatientsStatistics';
import {
  CardWrapper,
  CardHeaderWrapper,
  StyledTenantName,
  StyledTenantInfo,
  StyledTimezoneOffset,
} from './styled';
import { Tooltip } from 'antd';
import { ToolTipMessages } from 'src/translations/messages/toolTipMessages';
import { displayInTimezone, US_12H_TIME_FORMAT } from 'src/utils/timeUtils';
import dayjs from 'dayjs';

type Props = SubTenantOverview;

const SubtenantCard = (props: Props): JSX.Element => {
  const {
    id,
    name,
    address,
    timeZoneId,
    totalDevicesCounter,
    disconnectedAssignedDevicesCounter,
    disconnectedUnassignedDevicesCounter,
    connectedAssignedDevicesCounter,
    connectedUnassignedDevicesCounter,
    lastDayAlertsCounter,
    hasActiveAlert,
  } = props;

  const locationText = `${address.city || ''}${updateText(
    ', ',
    address.state,
  )}${updateText(', ', address.countryCode)}`;

  return (
    <CardWrapper>
      <CardHeaderWrapper>
        <StyledTenantName onClick={() => handleClickTenantName(id)}>
          <Tooltip
            title={
              <FormattedMessage {...ToolTipMessages.MtMtenantCardsTenantName} />
            }
          >
            {name}
          </Tooltip>
        </StyledTenantName>
        <IndividualSubtenantSettings subtenantId={id} />
      </CardHeaderWrapper>
      <StyledTenantInfo>
        {`${locationText}`}
        <StyledTimezoneOffset>
          {timeZoneId
            ? displayInTimezone(
                dayjs().format(),
                timeZoneId,
                US_12H_TIME_FORMAT,
              )
            : dayjs.utc().format(US_12H_TIME_FORMAT)}
        </StyledTimezoneOffset>
      </StyledTenantInfo>
      <DevicesStatistics
        id={id}
        name={name}
        totalDevicesCounter={totalDevicesCounter}
        disconnectedAssignedDevicesCounter={disconnectedAssignedDevicesCounter}
        disconnectedUnassignedDevicesCounter={
          disconnectedUnassignedDevicesCounter
        }
      />
      <PatientsStatistics
        id={id}
        name={name}
        lastDayAlertsCounter={lastDayAlertsCounter}
        hasActiveAlert={hasActiveAlert}
        connectedAssignedDevicesCounter={connectedAssignedDevicesCounter}
        connectedUnassignedDevicesCounter={connectedUnassignedDevicesCounter}
      />
    </CardWrapper>
  );
};

export default SubtenantCard;
